import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaChevronDown } from 'react-icons/fa';
import { courseGroups } from '../content/data';

const Courses = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <section id="courses" className="section-padding bg-page-light">
      <div className="section-container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
          className="text-center mb-10"
        >
          <h2 className="text-h1 gradient-text mb-3">Relevant Coursework</h2>
          <p className="text-muted text-body-lg">Academic foundation by domain</p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6 mb-6">
          {courseGroups.map((group, groupIndex) => (
            <motion.div
              key={group.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: groupIndex * 0.1 }}
              viewport={{ once: true }}
              className="card p-5"
            >
              <h3 className="text-h3 text-accent-blue mb-1">{group.title}</h3>
              <p className="text-muted text-caption mb-4">{group.description}</p>
              <ul className="space-y-2">
                {group.courses.slice(0, isExpanded ? undefined : 3).map((course, i) => (
                  <li key={i} className="text-caption">
                    <span className="text-white font-medium">{course.name}</span>
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>

        <AnimatePresence>
          {!isExpanded && (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              className="text-center"
            >
              <button
                onClick={() => setIsExpanded(true)}
                className="btn-ghost flex items-center gap-2 mx-auto"
              >
                View all courses
                <FaChevronDown className="text-sm" />
              </button>
            </motion.div>
          )}
        </AnimatePresence>

        <AnimatePresence>
          {isExpanded && (
            <motion.div
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: 'auto' }}
              exit={{ opacity: 0, height: 0 }}
              className="overflow-hidden"
            >
              <div className="text-center mt-4">
                <button
                  onClick={() => setIsExpanded(false)}
                  className="btn-ghost flex items-center gap-2 mx-auto"
                >
                  Show less
                  <FaChevronDown className="text-sm rotate-180" />
                </button>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </section>
  );
};

export default Courses;
